import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelopeOpenText,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Common_Banner from "../common/common-banner/Common_Banner";
import Submit_Modal from "../modals/submit-modal/Submit_Modal";
import "./Contact_Us.css";
import { createContact, GetAllAppsetup } from "../../redux/contain";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";

const Contact_Us = () => {
  const dispatch = useDispatch();
  const appsetup = useSelector((state) => state?.contain?.appsetup);
  useEffect(() => {
    dispatch(GetAllAppsetup());
  }, [dispatch]);

  console.log(appsetup, "appsetupappsetup");

  const [showPopup, setShowPopup] = useState(false);

  const socialIcons = [
    { icon: faInstagram, link: "https://www.instagram.com" },
    { icon: faWhatsapp, link: "https://wa.me/919999999999" },
    { icon: faLinkedinIn, link: "https://www.linkedin.com" },
    { icon: faFacebookF, link: "https://www.facebook.com" },
  ];

  const contactData = [
    {
      icon: <FontAwesomeIcon icon={faLocationDot} />,
      title: "Head office",
      desc:
        "Akshya Nagar 1st Block 1st Cross, Ramamurthy nagar, Bangalore-560016",
    },
    {
      icon: <FontAwesomeIcon icon={faEnvelopeOpenText} />,
      title: "Email Us",
      desc: "excellentcounselling@support.com",
    },
    {
      icon: <FontAwesomeIcon icon={faPhone} />,
      title: "Call Us",
      desc: "+91 5684526232",
      desc: "+91 5684526232",
    },
  ];

  const {
    register,
    control,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setShowModal(true); // open success modal

  //   // close modal after 3 seconds
  //   setTimeout(() => {
  //     setShowModal(false);
  //     navigate("/");
  //   }, 3000);
  // };
  const onSubmit = (data) => {
    console.log("DATA TO SEND: ", data);

    dispatch(createContact(data))
      .unwrap()
      .then(() => {
        reset(); // clear form
        setShowModal(true); // show success modal

        setTimeout(() => {
          setShowModal(true); // hide modal
          navigate("/"); // redirect to home
        }, 3000); // after 3 seconds
      })
      .catch((err) => {
        console.error("Submit Error:", err);
      });
  };

  const homebanner = useSelector((state) => state?.app_setup?.appsetup);

  console.log(homebanner, "homebanner");

  useEffect(() => {
    dispatch(GetAllAppsetup());
  }, [dispatch]);

  return (
    <section className="Contact_Us">
      <Common_Banner
        bannerImg="/assets/images/common-banner/contact.png"
        title="Contact Us"
      />

      <div className="contact_box">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3 contact_left">
              <h4 className="col_title">Get in Touch</h4>
              <p className="contact_desc">
                Reach out to us for career guidance, parental counselling, or
                workshop inquiries. We’re happy to assist you.
              </p>

              <div className="contact_item">
                <div className="icon">
                  <FontAwesomeIcon icon={faLocationDot} />
                </div>

                <div className="item_holder">
                  <h6 className="item_title">Head Office</h6>
                  <p className="item_desc">{homebanner.location}</p>
                </div>
              </div>
              <div className="contact_item">
                <div className="icon">
                  <FontAwesomeIcon icon={faEnvelopeOpenText} />
                </div>

                <div className="item_holder">
                  <h6 className="item_title">Email Us</h6>
                  <p className="item_desc">{homebanner.email}</p>
                </div>
              </div>
              <div className="contact_item">
                <div className="icon">
                  <FontAwesomeIcon icon={faPhone} />
                </div>

                <div className="item_holder">
                  <h6 className="item_title">Call Us</h6>
                  <p className="item_desc">+91 {homebanner.contact}</p>
                </div>
              </div>

              <div className="social_section">
                <h6 className="social_title">Follow us on social media:</h6>

                <div className="social_icons">
                  {socialIcons.map((item, i) => (
                    <a
                      key={i}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <FontAwesomeIcon icon={item.icon} />
                      </span>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3 contact_right">
              <h4 className="right_title">Send us a Message</h4>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-3 ">
                    {/* <Form.Group>
                      <Form.Label>First Name</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group> */}
                    <Form.Group className="form_group">
                      <Form.Label>Enter First Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your  First Name"
                        {...register("first_name", {
                          required: " First Name is required",
                        })}
                      />
                      {errors.first_name && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.first_name.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                    {/* <Form.Group>
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group> */}

                    <Form.Group className="form_group">
                      <Form.Label>Enter last Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your  last Name"
                        {...register("last_name", {
                          required: " last Name is required",
                        })}
                      />
                      {errors.last_name && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.last_name.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-sm-6 mb-3">
                    {/* <Form.Group>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control type="text" />
                    </Form.Group> */}

                    <Form.Group>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your contact"
                        {...register("number", {
                          required: "Contact is required",
                          pattern: {
                            value: /^[0-9]{10}$/, // <-- no quotes, this is a proper regex
                            message:
                              "Please enter a valid 10-digit contact number",
                          },
                        })}
                      />

                      {errors.number && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.number.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-lg-6 col-sm-6 mb-3">
                    {/* <Form.Group>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control type="email" />
                    </Form.Group> */}

                    <Form.Group className="form_group">
                      <Form.Label>Enter Email</Form.Label>
                      <Form.Control
                        //type="email"
                        type="text"
                        placeholder="Enter your email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            // A common regex pattern for email validation
                            //value: /^[^\s@]+@[^\s@]+\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                            // value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                            // value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                            value: /^[A-Za-z0-9](?:[A-Za-z0-9.+]*[A-Za-z0-9])?@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.(?:com|in|ac|net|org|info|co\.in|gov|edu|tech|io)$/i,
                            message: "Please enter a valid email address",
                          },
                        })}
                      />
                      {errors.email && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.email.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-12 mb-3">
                    <Form.Group className="form_group">
                      <Form.Label> Subject</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Type your subject here"
                        {...register("subject", {
                          required: "subject is required",
                        })}
                      />
                      {errors.subject && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.subject.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-12 mb-3">
                    <Form.Group className="form_group">
                      <Form.Label>Your Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="Type your Message here"
                        {...register("message", {
                          required: "Message is required",
                        })}
                      />
                      {errors.message && (
                        <p
                          style={{
                            color: "red",
                            marginTop: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {errors.message.message}
                        </p>
                      )}
                    </Form.Group>
                  </div>
                </div>

                <div className="submit_btn_div">
                  <button className="submit_btn" type="submit">
                    Submit
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>

      {/* MAP IFRAME */}

      <div className="contact_map">
        {/* {appsetup?.latitude && appsetup?.longitude ? ( */}
        <iframe
          src={`https://maps.google.com/maps?q=${appsetup?.latitude},${appsetup?.longitude}&hl=en&z=14&output=embed`}
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Google Map"
        ></iframe>
        {/* ) : null} */}
      </div>

      <Submit_Modal show={showModal} />
    </section>
  );
};

export default Contact_Us;
